module.exports = __webpack_public_path__ + "static/farmers_inventory-cedb2ea6b944ef365dc1bb758008fcab.png";